import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  HighPriorityNotifications,
  INotification,
  MediumPriorityNotifications,
} from '../../models/notification.models';

@Component({
  selector: 'app-notification',
  styleUrls: ['./notification.component.scss'],
  template: ` <div
    class="notif flex gap-2 justify-between"
    [ngClass]="notificationTypeClass"
    data-test-id="notification-item"
    (click)="route()"
  >
    <div class="flex flex-col gap-1" style="width: 100%">
      <div class="flex justify-between center-align">
        @for (content of textContent; track content) {
          <div>
            @if (content.text) {
              <div
                [innerHTML]="content.text.text | markdown"
                class="notification-message"
                data-test-id="notification-message"
              ></div>
            }
          </div>
        }
        <span class="time" data-test-id="notification-time-created">{{
          notification.dateCreated * 1000 | date: 'h:mma'
        }}</span>
      </div>
      <div class="flex justify-between">
        <span data-test-id="notification-expert-name"
          >{{ notification.firstName }} {{ notification.lastName }}</span
        >
        <span
          class="segment"
          [matTooltip]="notification.segment"
          matTooltipPosition="right"
          data-test-id="notification-expert-geography-segment"
        >
          {{ notification.segment }}
        </span>
      </div>
    </div>
  </div>`,
  standalone: false,
})
export class NotificationComponent {
  @Input() notification: INotification;
  @Output() archiveNotification = new EventEmitter<string>();
  @Output() routeAction = new EventEmitter<string>();

  get textContent() {
    return this.notification.content.filter((c) => c.contentType === 'message');
  }

  get actionContent() {
    return this.notification.content.filter(
      (c) => c.contentType === 'actionRow'
    );
  }

  get notificationTypeClass() {
    if (HighPriorityNotifications.includes(this.notification.type)) {
      return 'border-required';
    }

    if (MediumPriorityNotifications.includes(this.notification.type)) {
      return 'border-success';
    }

    return 'border-system';
  }

  archive() {
    this.archiveNotification.emit(this.notification.notificationId);
  }

  route() {
    const actions = this.notification.content.flatMap((c) =>
      c.contentType === 'actionRow' ? c.actions : []
    );

    if (actions.length) {
      const link = actions.find(Boolean).action.link;

      this.routeAction.emit(link);
    }
  }
}
